import { render, staticRenderFns } from "./LayoutBack.vue?vue&type=template&id=0f880dd9&scoped=true"
import script from "./LayoutBack.vue?vue&type=script&lang=js"
export * from "./LayoutBack.vue?vue&type=script&lang=js"
import style1 from "./LayoutBack.vue?vue&type=style&index=1&id=0f880dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f880dd9",
  null
  
)

export default component.exports